export default {
  // Nav
  'nav.services': '服務項目',
  'nav.cases': '成功案例',
  'nav.about': '關於我們',
  'nav.contact': '聯絡我們',
  'nav.cta': '免費諮詢',

  // Hero
  'hero.tag': '/ 區塊鏈全周期發行專家',
  'hero.title.line1': '讓數字產品',
  'hero.title.line2': '安全登陸鏈上',
  'hero.subtitle': '銳角40 Angle Forty 專注為數字產品提供安全、可靠的區塊鏈發行與部署服務，涵蓋規劃、發行、運營、優化的全周期解決方案。',
  'hero.cta.primary': '啟動您的鏈上部署',
  'hero.cta.secondary': '查看服務詳情',
  'hero.stat.projects': '已部署項目',
  'hero.stat.chains': '支持公鏈',
  'hero.stat.uptime': '平均可用率',
  'hero.stat.experts': '技術專家',

  // Marquee
  'marquee.item1': 'ETHEREUM · 以太坊',
  'marquee.item2': 'SOLANA · 索拉納',
  'marquee.item3': 'BNB CHAIN · 幣安鏈',
  'marquee.item4': 'POLYGON · 多邊形',
  'marquee.item5': 'ARBITRUM · 二層網絡',
  'marquee.item6': 'BASE · 基礎鏈',
  'marquee.item7': 'AVALANCHE · 雪崩鏈',

  // About
  'about.tag': '/ 公司概述',
  'about.title': '從規劃到優化，全周期鏈上護航',
  'about.desc': '銳角40 Angle Forty 由來自區塊鏈核心協議、金融科技與產品運營領域的資深團隊組建，服務全球超過 120 個數字產品項目安全上鏈。我們相信優秀的鏈上部署，不僅是一次發布，更是產品生命周期的長期陪伴。',
  'about.number': '01',
  'about.number.label': '全周期鏈上服務框架',
  'about.number.desc': '從市場調研、Tokenomics 設計、智能合約部署，到產品分發、數據監測與持續優化，四大階段無縫銜接，讓客戶專注於產品本身。',
  'about.cta': '了解服務框架',

  // Services
  'services.tag': '/ 核心服務',
  'services.title.line1': '區塊鏈發行',
  'services.title.line2': '數據監測運營',
  'services.desc': '四大階段，一體化交付。從策略規劃到長期優化，每一步都由專屬團隊護航。',
  'services.s1.title': '規劃諮詢',
  'services.s1.desc': '深入分析產品定位、目標鏈與代幣經濟模型，制定可執行的鏈上發行路線圖。',
  'services.s1.tag': 'Phase 01',
  'services.s2.title': '鏈上部署',
  'services.s2.desc': '智能合約審計、多鏈部署、安全防護，確保每一筆交易與資產都可靠可追溯。',
  'services.s2.tag': 'Phase 02',
  'services.s3.title': '產品運營',
  'services.s3.desc': '產品分發、社群運營、內容策略與活動策劃，助力項目高效觸達目標用戶。',
  'services.s3.tag': 'Phase 03',
  'services.s4.title': '技術支持',
  'services.s4.desc': '7×24 監測預警、數據分析儀表板與持續優化，讓項目穿越市場周期。',
  'services.s4.tag': 'Phase 04',
  'services.s.badge.hot': '熱門',

  // Cases
  'cases.tag': '/ 成功案例',
  'cases.title': '被信賴的鏈上夥伴',
  'cases.desc': '聚焦 NFT 數字藏品發行全鏈路，從藝術創作到鏈上部署的一站式實戰案例。',
  'cases.viewAll': '查看全部案例',
  'cases.c1.name': 'Pixel Origin',
  'cases.c1.category': 'NFT · 藝術品首發平台',
  'cases.c1.tvl': '發行額 2,800 ETH',
  'cases.c2.name': 'Vault Society',
  'cases.c2.category': 'NFT · 會員通行證',
  'cases.c2.tvl': '鑄造量 15,000+',
  'cases.c3.name': 'MetaForge',
  'cases.c3.category': 'NFT · 遊戲資產',
  'cases.c3.tvl': '交易量 1,200 萬美元',
  'cases.c4.name': 'Eden Drop',
  'cases.c4.category': 'NFT · 發行市場',
  'cases.c4.tvl': '月活 28 萬',

  // Testimonial
  'testimonial.tag': '/ 客戶評價',
  'testimonial.quote': '銳角40 讓我們在 6 週內完成了原本預計半年的多鏈部署，數據儀表板讓運營團隊第一次真正看清了鏈上業務。',
  'testimonial.author': 'Yvonne Liao',
  'testimonial.role': 'Pixel Origin 聯合創辦人',
  'testimonial.verified': '已驗證合作',

  // CTA
  'cta.tag': '/ 立即諮詢',
  'cta.title': '準備好開啟您的鏈上之旅了嗎？',
  'cta.desc': '留下您的項目信息，資深顧問將於 24 小時內與您聯繫，為您規劃專屬部署方案。',
  'cta.form.name': '您的姓名',
  'cta.form.email': '聯絡郵箱',
  'cta.form.company': '公司 / 項目名稱',
  'cta.form.type': '項目類型',
  'cta.form.type.nft.art': 'NFT 藝術品 / 數字藏品',
  'cta.form.type.nft.gaming': 'NFT 遊戲資產',
  'cta.form.type.nft.membership': 'NFT 會員 / 實用型',
  'cta.form.type.nft.marketplace': 'NFT 市場 / 發行平台',
  'cta.form.type.other': '其他',
  'cta.form.message': '簡述您的項目與需求（500 字以內）',
  'cta.form.submit': '立即發送諮詢',
  'cta.form.submitting': '發送中…',
  'cta.form.success': '感謝您的諮詢！我們將於 24 小時內聯繫您。',
  'cta.form.error': '提交失敗，請稍後再試或直接發送郵件至 hello@angleforty.com',

  // Footer
  'footer.brandDesc': '銳角40 Angle Forty · 讓每一個數字產品都能安全、優雅地登陸區塊鏈。',
  'footer.nav.title': '快速導航',
  'footer.contact.title': '聯絡資訊',
  'footer.social.title': '關注我們',
  'footer.newsletter': '訂閱動態',
  'footer.newsletter.desc': '每月一封，只發送深度行業洞察與案例覆盤。',
  'footer.newsletter.placeholder': '輸入您的郵箱',
  'footer.newsletter.button': '訂閱',
  'footer.address.title': '辦公地址',
  'footer.address.value': '香港中環皇后大道中9号',
  'footer.phone': '+852 3150 0000',
  'footer.email': 'hello@angleforty.com',
  'footer.copyright': '© 2026 Angle Forty Technology Ltd. 保留所有權利。',
  'footer.policy.privacy': '隱私政策',
  'footer.policy.terms': '服務條款',

  // Language
  'lang.zh-Hant': '繁中',
  'lang.zh-Hans': '简中',
  'lang.en': 'EN',
  'lang.ja': '日文',
  'lang.ko': '한국어',
};